var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main-header-container", {
    attrs: { title: _vm.title, infoToggleBtn: false, menu: false },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }